import {
    BaseCollectionModel,
    SearchModel,
    yascCreateEntityApiRoutesV3,
    YascEntityApiAdapterV3,
    YascEntityApiRoutesV3
} from '@yasc/yasc-material-components';
import {
    DeviceDataMinRes,
    DeviceDataRequest,
    DeviceDataRes,
    DeviceDataUReq
} from '../../../../contracts/v0/contracting/device-data.contracts';
import {Observable} from "rxjs";
import {ApiV0Contracting} from '../api.v0.contracting';
import {RestApiService} from '../../../rest-api.service';

export class ApiV0DeviceDataV3 implements YascEntityApiAdapterV3<DeviceDataMinRes, DeviceDataRes, DeviceDataRequest, DeviceDataUReq> {
    modelTypes = {
        row: DeviceDataMinRes,
        detail: DeviceDataRes,
        create: DeviceDataRequest,
        update: DeviceDataUReq,
    }
    readonly idKey = 'guid' as const;
    readonly segment: string;
    readonly routes: YascEntityApiRoutesV3<number>;

    constructor(v0: ApiV0Contracting, private readonly rest: RestApiService) {
        this.segment = v0.segment + '/deviceData';
        this.routes = yascCreateEntityApiRoutesV3(this.segment);
    }

    search(search?: SearchModel): Observable<BaseCollectionModel<DeviceDataMinRes>> {
        return this.rest.post<SearchModel, BaseCollectionModel<DeviceDataMinRes>>(this.routes.search, DeviceDataMinRes, search);
    }

    detail(id: string): Observable<DeviceDataRes> {
        return this.rest.get<DeviceDataRes>(this.segment + `/${id}`, DeviceDataRes);
    }

    create(request: DeviceDataRequest): Observable<DeviceDataRes> {
        return this.rest.post<DeviceDataRequest, DeviceDataRes>(this.routes.base, DeviceDataRes, request);
    }

    patch(id: string , request: DeviceDataUReq): Observable<DeviceDataRes> {
        return this.rest.patch<DeviceDataUReq, DeviceDataRes>(this.segment + `/${id}`, DeviceDataRes, request);
    }
    delete(ids: string[]): Observable<void>{
        return this.rest.delete<void>(this.segment, Object as any, ids);
    }
}